// @ts-nocheck
import React, { useCallback } from 'react';
import { Button, Intent } from '@blueprintjs/core';
import { compose } from '@/utils';
import { Icon, FormattedMessage as T } from '@/components';
import withDialogActions from '@/containers/Dialog/withDialogActions';
import { DialogsName } from '@/constants/dialogs';

function ShipMethodsActions({ openDialog }) {
  const handleClickNew = useCallback(() => {
    openDialog(DialogsName.ShipMethodForm);
  }, [openDialog]);

  return (
    <div className="ship-methods-actions">
      <Button
        icon={<Icon icon="plus" iconSize={12} />}
        onClick={handleClickNew}
        intent={Intent.PRIMARY}
        style={{ backgroundColor: '#1890FF' }}
      >
        <T id={'new_ship_method'} />
      </Button>
    </div>
  );
}

export default compose(withDialogActions)(ShipMethodsActions);
